import TableCell from '@material-ui/core/TableCell';
import * as React from 'react';
import { ITableHeader } from '../SmartTable';

interface ISmartTableCell<T> {
  item: T
  header: ITableHeader<T>
}

export default class SmartTableCell<T> extends React.PureComponent<ISmartTableCell<T>, {}> {
  public render() {
    const {
      item,
      header,
    } = this.props;
    return (
      <TableCell>
        {header.render(item)}
      </TableCell>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/smartTable/SmartTableCell.tsx